import { Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

export const TextUpload = styled(Text)`
    width: 150px;
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-2, #616161);
    text-align: center;

    font-size: 10px;
    font-style: normal;
    line-height: 12px; /* 120% */
    font-weight: 400;
    span {
        font-weight: 700;
    }
`;

export const IconUpload = styled(Flex)`
    border-radius: 4px;
    background: var(--Light-theme-Rest-Background-Brand-Background, #5b5fc7);
    width: 36px;
    height: 26px;
`;

export const Wrapper = styled(Flex)`
    height: 102px;

    border-radius: 4px;
    border: 2px dashed var(--Light-theme-Rest-Border-Brand-Border-2, #c5cbfa);
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14),
        0px 0px 2px 0px rgba(0, 0, 0, 0.12);
`;

export const TextStyle = styled(Text)`
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    color: #616161;
`;

export const baseStyle = {
    cursor: "pointer",
};

export const focusedStyle = {
    borderColor: "#2196f3",
};

export const acceptStyle = {
    borderColor: "#00e676",
};

export const rejectStyle = {
    borderColor: "#ff1744",
};
